import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import H5 from 'UIComponents/elements/headings/H5';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SaveViewShepherd({
  children,
  isCurrentViewModified,
  isReadOnly,
  onOpenChange,
  onResetClick,
  onSaveAsNewClick,
  onSaveViewClick,
  open
}) {
  const headerMessage = !isReadOnly ? 'frameworkListingLib.viewTabs.saveButtonPopover.header.editable' : 'frameworkListingLib.viewTabs.saveButtonPopover.header.readOnly';
  const bodyMessage = !isReadOnly ? 'frameworkListingLib.viewTabs.saveButtonPopover.body.editable' : 'frameworkListingLib.viewTabs.saveButtonPopover.body.readOnly';
  return /*#__PURE__*/_jsx(UIPopover, {
    closeOnOutsideClick: true,
    content: {
      header: /*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: headerMessage
        })
      }),
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: bodyMessage
      }),
      footer: /*#__PURE__*/_jsxs(UIList, {
        firstChildClassName: "p-bottom-4",
        children: [/*#__PURE__*/_jsxs(UIFlex, {
          gap: 12,
          wrap: "wrap",
          children: [/*#__PURE__*/_jsx(UIButton, {
            "data-test-id": "crm-listing-popover-save-view-button",
            disabled: isReadOnly,
            onClick: onSaveViewClick,
            use: "tertiary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "frameworkListingLib.viewTabs.saveButtonPopover.footer.saveButton"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            "data-test-id": "crm-listing-popover-reset-button",
            disabled: !isCurrentViewModified,
            onClick: onResetClick,
            use: "tertiary-light"
            // UIButton automatically adds marginLeft to n+1 buttons
            // But we're handling spacing with flex-gap
            ,
            style: {
              marginLeft: 0
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "frameworkListingLib.viewTabs.saveButtonPopover.footer.resetButton"
            })
          })]
        }), /*#__PURE__*/_jsx(UILink, {
          "data-test-id": "crm-listing-popover-save-as-new-link",
          underline: true,
          onClick: onSaveAsNewClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "frameworkListingLib.viewTabs.saveButtonPopover.footer.saveAsButton"
          })
        })]
      })
    },
    "data-test-id": "save-view-shepherd",
    onOpenChange: onOpenChange,
    open: open,
    placement: "bottom left",
    width: 300,
    children: children
  });
}